import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfoCircleGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M20.207 3.793C18.287 1.873 15.487 1 12 1s-6.287.873-8.207 2.793S1 8.513 1 12s.873 6.287 2.793 8.207S8.513 23 12 23s6.287-.872 8.207-2.793C22.127 18.287 23 15.487 23 12s-.872-6.287-2.793-8.207m-1.414 1.414C20.206 6.62 21 8.821 21 12s-.794 5.38-2.207 6.793S15.179 21 12 21s-5.38-.794-6.793-2.207S3 15.179 3 12s.794-5.38 2.207-6.793S8.821 3 12 3s5.38.794 6.793 2.207'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      d='M12 5.5A1.25 1.25 0 1 0 12 8a1.25 1.25 0 0 0 0-2.5M13.25 18a1 1 0 1 0 0-2v-6a1 1 0 0 0-1.447-.894l-1 .5a1 1 0 0 0 .447 1.894V16a1 1 0 1 0 0 2z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInfoCircleGhost)
export default ForwardRef
